import http from './http'

const usuariosprofissionaisService = {
  getAll: page => http.get(`/usuariosprofissionais?page=${page}`).then(result => result.data),
  getById: id => http.get(`/usuariosprofissionaisgetid/${id}`).then(result => result.data.data),
  getByAll: () => http.get(`/usuariosprofissionais`).then(result => result.data),
  getByUsuario: () => http.get(`/usuariosprofissionaisall`).then(result => result.data),
  // getByNome: (str, page) => http.get(`/usuariosprofissionaisgetnome/${str}?page=${page}`).then(result => result.data),
  delete: id => http.delete(`/usuariosprofissionaisdelete/${id}`).then(result => result.data.data),
  savePost: data => http({
    method: 'post',
    url: `/usuariosprofissionais`,
    data
  }).then(result => result.data.data),
  savePut: data => http({
    method: 'put',
    url: `/usuariosprofissionais/${data.id}`,
    data
  }).then(result => result.data.data)
}

export default usuariosprofissionaisService
